import { render, staticRenderFns } from "./FullWidthCell.vue?vue&type=template&id=28c3aae1&scoped=true"
import script from "./FullWidthCell.vue?vue&type=script&lang=js"
export * from "./FullWidthCell.vue?vue&type=script&lang=js"
import style0 from "./FullWidthCell.vue?vue&type=style&index=0&id=28c3aae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3aae1",
  null
  
)

export default component.exports